import { styled, Tag as BaseTag, TagProps } from '@bcp-nextgen-dx-component-factory/accolade-design-system';

const TagWithoutBorder = styled.div`
	& > button {
		border: 0 none;
	}
`;

export const Tag: React.FC<TagProps> = (props) => {
	return (
		<TagWithoutBorder>
			<BaseTag {...props} />
		</TagWithoutBorder>
	);
};
